import type { MetaFunction } from "@remix-run/cloudflare";
import { loader } from "./loader";

export const meta: MetaFunction<typeof loader> = ({ data, location }) => {
  if (!data) return [];

  const { searchAreas, parameterSearchAreaIds } = data;

  let title = "求人一覧 | 飲食店の正社員求人・転職はエフジョブ求人";
  let description = "理想の転職を飲食業界のプロと一緒に実現するエフジョブ求人";

  // Area Search only
  const isAreaOnlySearch =
    location.search.startsWith("?search_area_ids=") &&
    !location.search.includes("occupation_type_ids") &&
    !location.search.includes("service_type_ids");

  if (isAreaOnlySearch && parameterSearchAreaIds.length > 0) {
    const TOKYO_AREA_IDS = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24,
    ];

    // All Tokyo areas selected
    if (
      parameterSearchAreaIds.length === TOKYO_AREA_IDS.length &&
      parameterSearchAreaIds.every((id) => TOKYO_AREA_IDS.includes(id))
    ) {
      title =
        "東京都の飲食店求人・募集情報一覧｜飲食店の正社員求人・転職はエフジョブ求人";
      description =
        "東京都の飲食店求人・情報一覧です。エフジョブ求人では、あなたの理想の転職を飲食業界のプロと一緒に実現。飲食店の業態や職種などから、あなたの希望の仕事を見つけられます。";
    }
    // Single area selected
    else if (parameterSearchAreaIds.length === 1) {
      const areaId = parameterSearchAreaIds[0];
      const area = searchAreas.find((a) => a.id === areaId);
      if (area) {
        if (area.id === 24) {
          title = `町田市・立川市・八王子市等ほかエリアの飲食店求人・募集情報一覧｜飲食店の正社員求人・転職はエフジョブ求人`;
          description = `町田市・立川市・八王子市等東京都23区外の飲食店求人・情報一覧です。エフジョブ求人では、あなたの理想の転職を飲食業界のプロと一緒に実現。飲食店の業態や職種などから、あなたの希望の仕事を見つけられます。`;
        } else {
          title = `${area.name}の飲食店求人・募集情報一覧｜飲食店の正社員求人・転職はエフジョブ求人`;
          description = `${area.name}の飲食店求人・情報一覧です。エフジョブ求人では、あなたの理想の転職を飲食業界のプロと一緒に実現。飲食店の業態や職種などから、あなたの希望の仕事を見つけられます。`;
        }
      }
    }
  }
  return [
    { title },
    {
      name: "description",
      content: description,
    },
    {
      property: "og:title",
      content: title,
    },
    {
      property: "og:description",
      content: description,
    },
    {
      property: "og:type",
      content: "article",
    },
    {
      property: "og:image",
      // NOTE: 関数外で現環境を特定する方法がぱっとわからなかったので、ハードコーディング使用
      // NOTE: 環境関係なく本番のR2を見に行くようにしている
      content: "https://public.fjob-kyujin.com/public/ogimage.png",
    },
    {
      property: "og:url",
      content: `https://fjob-kyujin.com${location.pathname}${location.search}`,
    },
    {
      name: "twitter:card",
      content: "summary_large_image",
    },
  ];
};
